module.exports = __webpack_public_path__ + "img/视频.39d08450.png";